import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { AddonsActions, AddonsDetailTabs } from "@/resources-def/addons-comp";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useTranslation } from "react-i18next";
const RESOURCE = 'addons';

export const AddonsPage = () => {
  const { t } = useTranslation();

  const navigate = useResourceNavigate();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: "settings/" + RESOURCE, key: record.id, action: 'show', queryParam: '?type=' + record.type });
  };
  
  const columns = [
    { title: "Id", dataIndex: "id", key: "id" },
    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Name", dataIndex: "name", key: "name", render: (text, record) => <a onClick={(e) => navigateToDetail(record, e) }>{text}</a> },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Category", dataIndex: "category", key: "category" },
    { title: "Provider", dataIndex: "provider", key: "provider" },
    { title: "Description", dataIndex: "desc", key: "desc"}
  ];
  return (
    <ResourceListLayout
      title={"AIOps add-ons"}
      resource={RESOURCE}
      actions={AddonsActions}
      columns={columns}
      details={AddonsDetailTabs}
    >
    </ResourceListLayout>
  );
};